
export default {
  i18nComponentKey: 'ReviewsNew.components.FieldReward',
  name: 'FieldReward',
  props: {
    value: { type: Number, required: true },
    maxValue: { type: Number, required: true }
  },
  computed: {
    progress() {
      return this.value / this.maxValue;
    }
  }
};
